import ClinicalTrainingEvent, { ClinicalTrainingEventModal } from './clinical-training-event';
import { ListStatus, EditableStatus } from '@/store/types';

export enum ClinicalTrainingEventsActions {
  LOAD_ALL = 'LOAD_ALL',
  LOAD_EDITABLE = 'LOAD_EDITABLE',
  LOAD_ACTIVE = 'LOAD_ACTIVE',
  CREATE = 'CREATE',
  SAVE = 'SAVE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
  APPLY_FILTERS = 'APPLY_FILTERS',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  LOAD_PRODUCTS = 'LOAD_PRODUCTS',
  SUBSCRIBE = 'SUBSCRIBE',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
  
  /**
   * Bulk actions
   */
  BULK_DELETE = 'BULK_DELETE',
  BULK_RESTORE = 'BULK_RESTORE',
}

export enum ClinicalTrainingEventsMutations {
  SET_ALL = 'SET_ALL',
  SET_ALL_STATUS = 'SET_ALL_STATUS',
  SET_EDITABLE = 'SET_EDITABLE',
  SET_EDITABLE_STATUS = 'SET_EDITABLE_STATUS',
  SET_LIST_PAGINATION = 'SET_LIST_PAGINATION',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  UPDATE_INITIAL_EDITABLE = 'UPDATE_INITIAL_EDITABLE',
  UPDATE_EVENT = 'UPDATE_EVENT',
  SET_PRODUCTS = 'SET_PRODUCTS',
}

export interface ClinicalTrainingEventsState {
  list: ClinicalTrainingEventModal[];
  listStatus: ListStatus;
  listPagination: {
    currentPage: number;
    lastPage: number;
    total: number;
  };
  editable: ClinicalTrainingEvent | null;
  initialEditable: ClinicalTrainingEvent | null;
  editableStatus: EditableStatus;
  products: { id: number; title: string }[];
}

export interface ClinicalTrainingEventsFilters {
  search?: string;
  status?: number;
  product?: number;
  page?: number;
}
